import { Response } from 'request-dot-js'
import { FilesView } from 'api/clients/FilesViewsClient'
import { useInfiniteQuery, UseInfiniteQueryOptions } from 'react-query'
import { sendToApi } from 'api/client'
import qs from 'qs'
import { useCurrentWorkspaceId } from '../../useCurrentWorkspaceId'
import { getNextPageParam } from 'utils/getNextPageParam'
import { defaultLongCacheTime } from '../../../queryClient'

interface Options {
  query?: object
}

const fetchRecentFiles = (workspaceId: number, options: Options) => {
  const queryString = qs.stringify(options.query)

  return ({ pageParam = 1 }) => {
    return sendToApi<{ articles: FilesView['files'] }>(
      `/w/${workspaceId}/articles/recently_viewed?page=${pageParam}&${queryString}`,
      {
        method: 'GET',
      },
    )
  }
}

export const useRecentArticles = (
  options: Options = { query: {} },
  reactQueryOptions?: UseInfiniteQueryOptions<Response<{ articles: FilesView['files'] }>>,
) => {
  const workspaceId = useCurrentWorkspaceId()

  return useInfiniteQuery<Response<{ articles: FilesView['files'] }>>(
    ['workspace', workspaceId, 'articles', 'recently-viewed', options.query],
    fetchRecentFiles(workspaceId, options),
    {
      cacheTime: defaultLongCacheTime,
      refetchOnWindowFocus: false,
      getNextPageParam,
      ...reactQueryOptions,
    },
  )
}
